export const TEQTANK_COMMERCE_SDK_VERSION = "0.17.0" as const;
